import type { Preferences } from "@/core/types";

import { ProfileSidebar } from "../../(shared)/(profile)/components/ProfileSidebar";
import { UserProfile } from "../../(shared)/(profile)/UserProfile";

import { AdminCalendarPreferencesCard } from "./components/AdminCalendarPreferencesCard";
import { AssociatedPracticeCard } from "./components/AssociatedPracticeCard";
import { BasicInfoCard } from "./components/BasicInfoCard";
import { LcswPermissionSelf } from "./components/lcsw/LcswPermissionSelf";
import { useAdminProfile } from "./api/queries/useAdminProfile";
import { useUpdateAdminProfile } from "./api/mutations/useUpdateAdminProfile";

export function AdminProfile() {
  const { data: profileData, isLoading } = useAdminProfile();
  const { mutateAsync } = useUpdateAdminProfile({
    meta: { component: "AdminProfile" },
  });

  const handleUpdatePreferences = (preferences: Preferences) => mutateAsync({ preferences });

  return (
    <UserProfile
      asideContent={profileData ? <ProfileSidebar profileData={profileData} /> : null}
      isLoading={isLoading || !profileData}
      renderMainContent={() =>
        profileData ? (
          <>
            <BasicInfoCard isReadOnly profileData={profileData} />
            <LcswPermissionSelf profileData={profileData} userId={profileData.username} />
            <AdminCalendarPreferencesCard
              onUpdate={handleUpdatePreferences}
              preferences={profileData.preferences}
            />
            <AssociatedPracticeCard />
          </>
        ) : null
      }
    />
  );
}
